import { Component, Output, EventEmitter, Input } from '@angular/core';
@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent {

  files: any[] = [];

  @Input() loading: boolean = false;
  // Accepted file types for the native picker. Defaults to Excel (the component's prior hardcoded
  // value), so existing usages are unchanged; callers can override (e.g. to also allow CSV).
  @Input() accept: string = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  constructor() { }

  filesDropped(files: any): void {
    this.files = files;
    this.onChange.emit(this.files);
  }

  deleteFile() {
    this.files = [];
    this.onChange.emit(this.files);
  }

}
